import { Check, Monitor, Moon, Sun } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { useTheme, type ThemePreference } from "~/lib/theme/context";
import { cn } from "~/lib/utils";

const OPTIONS: { value: ThemePreference; label: string; icon: typeof Sun }[] = [
  { value: "light", label: "Light", icon: Sun },
  { value: "dark", label: "Dark", icon: Moon },
  { value: "system", label: "System", icon: Monitor },
];

export function ThemeToggle() {
  const { preference, resolved, setPreference } = useTheme();
  const TriggerIcon = resolved === "dark" ? Moon : Sun;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={`Theme: ${preference}`}
        className="hover:border-foreground/25 text-text-faint hover:text-foreground border-hairline bg-surface inline-flex size-7 items-center justify-center rounded-md border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40"
      >
        <TriggerIcon className="size-3.5" strokeWidth={1.75} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={6} className="min-w-[140px]">
        {OPTIONS.map((opt) => {
          const active = preference === opt.value;
          return (
            <DropdownMenuItem
              key={opt.value}
              onSelect={() => setPreference(opt.value)}
              className={cn("justify-between", active && "text-foreground")}
            >
              <span className="flex items-center gap-2">
                <opt.icon className="size-3.5" strokeWidth={1.75} />
                {opt.label}
              </span>
              {active && <Check className="size-3.5" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
